import { useEffect, useState } from "react";
import { useVendorAuth } from "../../store/vendorAuthStore";
import { vendorAuthApi } from "../../services/auth";
import { vendorApi } from "../../services/vendorApi";
import "../Auth/auth.css";

export default function BankDetails() {
  const { token, vendor, setVendor } = useVendorAuth();

  const [form, setForm] = useState({
    account_holder: "", bank_name: "",
    account_no: "", ifsc: "", upi_id: "",
  });

  const [loading,  setLoading]  = useState(false);
  const [fetching, setFetching] = useState(true);
  const [msg,      setMsg]      = useState("");
  const [isErr,    setIsErr]    = useState(false);

  // ✅ Fetch fresh from DB on mount
  useEffect(() => {
    const vendorId = vendor?.id || vendor?.vendor_id ||
      (() => { try { return JSON.parse(localStorage.getItem("vendor_me") || "{}")?.id || ""; } catch { return ""; } })();
    const authToken = token || localStorage.getItem("vendor_token") || "";

    if (!vendorId) { setFetching(false); return; }

    (async () => {
      try {
        const v = await vendorAuthApi.getProfile(vendorId, authToken);
        setForm({
          account_holder: v.account_holder || "",
          bank_name:      v.bank_name      || "",
          account_no:     v.account_no     || "",
          ifsc:           v.ifsc           || "",
          upi_id:         v.upi_id         || "",
        });
        setVendor(v);
      } catch (e) {
        if (vendor) {
          setForm({
            account_holder: vendor.account_holder || "",
            bank_name:      vendor.bank_name      || "",
            account_no:     vendor.account_no     || "",
            ifsc:           vendor.ifsc           || "",
            upi_id:         vendor.upi_id         || "",
          });
        }
      } finally {
        setFetching(false);
      }
    })();
  }, []); // eslint-disable-line

  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.account_holder.trim()) { setMsg("Account Holder Name required"); setIsErr(true); return; }
    if (!form.bank_name.trim())      { setMsg("Bank Name required");            setIsErr(true); return; }
    if (!form.account_no.trim())     { setMsg("Account Number required");       setIsErr(true); return; }
    if (!form.ifsc.trim())           { setMsg("IFSC Code required");            setIsErr(true); return; }

    setMsg(""); setIsErr(false);
    setLoading(true);
    try {
      await vendorApi.updateBank(token, form);
      setVendor(form);
      setMsg("Bank details updated successfully.");
      setIsErr(false);
    } catch (err) {
      setMsg(err.message || "Update failed.");
      setIsErr(true);
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="ep-page">
        <div className="ep-card" style={{ textAlign: "center", padding: 48, color: "var(--color-text-secondary)" }}>
          ⏳ Loading bank details...
        </div>
      </div>
    );
  }

  return (
    <div className="ep-page">
      <div className="ep-head">
        <div className="ep-icon-box">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
            <line x1="1" y1="10" x2="23" y2="10"/>
          </svg>
        </div>
        <div>
          <h2 className="ep-title">Bank Details</h2>
          <div className="ep-sub">Manage your payout bank account</div>
        </div>
      </div>

      <div className="ep-card">
        <div className="ep-section-title">Account Information</div>
        {msg && <div className={`v-alert ${isErr ? "v-alert-error" : "v-alert-ok"}`}>{msg}</div>}

        <form onSubmit={submit}>
          <div className="ep-grid2">
            <div className="ep-field">
              <label className="ep-label">Account Holder Name</label>
              <input className="ep-input" value={form.account_holder} onChange={set("account_holder")} placeholder="Enter holder name" />
            </div>
            <div className="ep-field">
              <label className="ep-label">Bank Name</label>
              <input className="ep-input" value={form.bank_name} onChange={set("bank_name")} placeholder="Enter bank name" />
            </div>
            <div className="ep-field">
              <label className="ep-label">Account Number</label>
              <input className="ep-input" value={form.account_no} onChange={set("account_no")} placeholder="Enter account number" />
            </div>
            <div className="ep-field">
              <label className="ep-label">IFSC Code</label>
              <input className="ep-input" value={form.ifsc} onChange={set("ifsc")} placeholder="Enter IFSC code" />
            </div>
            <div className="ep-field">
              <label className="ep-label">UPI ID (optional)</label>
              <input className="ep-input" value={form.upi_id} onChange={set("upi_id")} placeholder="Enter UPI ID" />
            </div>
          </div>
          <div className="ep-footer">
            <button className="ep-next-btn" type="submit" disabled={loading}>
              {loading ? "Saving..." : "Save Changes →"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}